import { PageHeader } from "@/widgets/page-header"
import { TelegramTextEditor } from "@/shared/ui/telegram-rich-text-editor"
import TelegramSvg from "@/shared/assets/images/Telegram.svg"
import { useMemo, useRef, useState } from "react"
import XSvg from '@/shared/assets/images/X.svg'
import { broadcast, IBroadcastRequest } from "@/shared/api/notifications"
import notify from "@/shared/lib/notify"
import { useAppSelector } from "@/shared/lib/redux"
import { selectEmployeesGroups, selectUsersGroups } from "@/entities/groups"
import { Select } from "@/shared/ui/select/select"
import { GroupBase, OptionsOrGroups } from "react-select"
import { getErrorMessage } from "@/shared/consts/error-codes"

interface GroupSelect { 
    label: string, 
    value: {
        id: string, 
        type: "socialGroup" | "group"
    }
}

export const NotificationsPage = () => {
    const fileInputRef = useRef<HTMLInputElement>(null)
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [image, setImage] = useState<File>(undefined)
    const [markup, setMarkup] = useState<string>('')
    const userGroups = useAppSelector(selectUsersGroups)
    const employeeGroups = useAppSelector(selectEmployeesGroups)
    const [selectedGroups, setSelectedGroups] = useState<GroupSelect[]>([])

    const groupsSelectOptions: OptionsOrGroups<any, GroupBase<any>> = useMemo(() => [
        {
            options: userGroups.map(group => ({
                label: group.name,
                value: {
                    id: group.id,
                    type: "group"
                }
            })),
            label: 'Пользователи'
        },
        {
            options: employeeGroups.map(group => ({
                label: group.name,
                value: {
                    id: group.id,
                    type: "group"
                }
            })),
            label: 'Сотрудники'
        }
    ], [userGroups, employeeGroups])

    const onClick = async () => {
        setIsLoading(true)
        const formData = new FormData()
        formData.append('image', image)
        formData.append('message', markup)
        selectedGroups.forEach((selected) => {
            if (selected.value.type === 'group') {
                formData.append("groupId[]", selected.value.id)
            }
        })
        await broadcast(formData as unknown as IBroadcastRequest)
            .then(() => {
                notify.success('Рассылка успешно отправлена')
            })
            .catch((e) => {
                notify.error(getErrorMessage(e.response?.data?.error_id))
            })
            .finally(() => {
                setIsLoading(false)
            })
    }

    return (
        <div className="_page_container">
            <PageHeader title="Рассылки" />
            <div className="flexbox">
                <div className={`font-mediumttf gap-4 flex items-center uppercase text-2xl leading-[24px] py-6 px-5 rounded-2xl w-full bg-[#27A7E7] text-white`}>
                    <div className="bg-gradient-to-b fill-white text-white w-[52px] h-[52px] rounded-xl flex items-center justify-center from-[#475361] to-[#1D1D1D]">
                        <TelegramSvg width={32} height={28} />
                    </div>
                    <div>
                        РАССЫЛКА В TELEGRAM
                    </div>
                </div>
                <div>
                    <Select
                        value={groupsSelectOptions.map(i => i.options).flat().filter((i) => selectedGroups.find(sg => sg.value.id === i.value.id))}
                        placeholder="Все группы"
                        onChange={(e: GroupSelect[]) => setSelectedGroups(e.map((i) => i))}
                        isMulti
                        options={groupsSelectOptions}
                    />
                </div>
                <div className="p-6 flex flex-col h-full bg-white rounded-2xl screen:rounded-3xl">
                    <div className="flex w-full">
                        <div className="flex-1 w-full">
                            <TelegramTextEditor
                                onInputChange={setMarkup}
                            />
                        </div>
                    </div>
                    <div className="flex pt-4 gap-3 flex-col border-t border-[#EAECF0]">
                        <div className='flex'>
                            <button onClick={() => fileInputRef?.current?.click()} className='bg-[#f0efef] font-semibold relative rounded-[4px] w-12 h-9'>
                                +
                            </button>
                            {image &&
                                <div className='px-2 my-auto bg-primary flex items-center ml-2 text-color-dark py-[2px] rounded-sm'>
                                    <div>
                                        {image.name}
                                    </div>
                                    <div className='h-full w-[1px] bg-white px-[2px]' />
                                    <button onClick={() => setImage(undefined)}>
                                        <XSvg width={16} height={16}/>
                                    </button>
                                </div>
                            }
                            <input
                                type="file"
                                className='hidden absolute'
                                ref={fileInputRef}
                                onChange={(e) => e.target.files?.length && setImage(e.target.files[0])}
                            />
                        </div>
                        <button disabled={isLoading} onClick={onClick} className="form_handle_button !w-fit !px-8">
                            Отправить рассылку
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}